module.exports = {
  email: 'taciano.dev@gmail.com',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/pedrotaciano',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/pedro.taciano',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/pedrotaciano',
    },
  ],

  navLinks: [
    {
      name: 'about',
      url: '/#about',
    },
    {
      name: 'experience',
      url: '/#jobs',
    },
    {
      name: 'work',
      url: '/#projects',
    },
    {
      name: 'contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#64ffda',
    black: '#000',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
